import {ReactElement, useState} from "react";
import MaterialToggleIcon from "../../icons/MaterialToggleIcon";

import './SidebarRow.scss'

type Props = {
  title: string
  indicator?: any
  collapsable?: boolean
  noBold?: boolean
  children: ReactElement | null
}

export default (props: Props) => {
  const [collapsed, setCollapsed] = useState(false)

  const classNames = ['sidebar-row']
  if (props.noBold) {
    classNames.push('no-bold')
  }
  if (props.collapsable) {
    classNames.push('collapsable')
    if (collapsed) {
      classNames.push('collapsed')
    }
  }

  const onTitleClick = () => {
    if (!props.collapsable) {
      return
    }
    setCollapsed(!collapsed)
  }

  return <section className={classNames.join(' ')}>
    <header>
      <div className="title" onClick={onTitleClick}>
        {props.title}

        {props.collapsable ? (
          <>
            {new MaterialToggleIcon('keyboard_arrow_down', 'keyboard_arrow_up').get(collapsed)}
          </>
        ) : null}
      </div>
      {props.indicator ? (
        <>
          <div className="stretch"></div>
          <div className="indicator">
            {props.indicator}
          </div>
        </>
      ) : null}
    </header>
    <div className="content">
      {props.children}
    </div>
  </section>
}